import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { sourceserviceClient } from '#pplx_generated/typespec/rest/sourceservice/client.js';
export async function fetchSourceById(sourceId, reason) {
    // The sourceservice TypeSpec intentionally omits the /{source_id} route to prevent
    // openapi-typescript from generating a greedy template literal that shadows all
    // /rest/sources/* sibling routes. We construct the URL manually instead.
    //
    // SAFETY: At runtime, GET /rest/sources/{source_id} returns a single source object
    // (LocalMCPSource | StandardSource), not the list response GetAvailableSourcesResponse.
    // The cast through unknown is required because the typed client sees the '/rest/sources'
    // list endpoint signature. The response shape matches ApiSource (a union member of
    // GetAvailableSourcesResponse.sources).
    const { data, response, error } = await sourceserviceClient.GET(`/rest/sources/${encodeURIComponent(sourceId)}`, reason, {
        normalizedPath: '/rest/sources/{source_id}',
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: `Failed to fetch source ${sourceId}`,
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
}
export async function fetchSourceByLink(identifier, reason) {
    const { data, response, error } = await sourceserviceClient.GET('/rest/sources/resolve-link/{identifier}', reason, { params: { path: { identifier } } });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to resolve connector link',
            status: response.status ?? 0,
        });
    }
    return data;
}
//# sourceMappingURL=fetchSourceById.js.map